/* JC Stays - theme-vc (Coastal Editorial)
   Main JS: header scroll, header dropdown, mobile drawer, mobile destinations
   accordion, field guide tabs/carousels, hero photo carousel, form submit.

   All init functions are wrapped via safeInit() so that one failing init
   doesn't break the rest of the page.
*/

(function () {
    'use strict';

    function safeInit(name, fn) {
        try { fn(); }
        catch (err) {
            console.error('[theme-vc] init "' + name + '" failed:', err);
        }
    }

    function initHeaderScroll() {
        var header = document.querySelector('.site-header');
        if (!header) return;
        var onScroll = function () {
            header.classList.toggle('is-scrolled', window.scrollY > 60);
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
    }

    function initHeaderDropdown() {
        var triggers = document.querySelectorAll('[data-dropdown-trigger]');
        if (!triggers.length) return;

        Array.prototype.forEach.call(triggers, function (trigger) {
            var item = trigger.closest('[data-dropdown]');
            if (!item) return;
            var panel = item.querySelector('.site-header__megamenu, .site-header__dropdown');
            if (!panel) return;

            function open() {
                item.classList.add('is-open');
                trigger.setAttribute('aria-expanded', 'true');
            }
            function close() {
                item.classList.remove('is-open');
                trigger.setAttribute('aria-expanded', 'false');
            }
            function isOpen() {
                return item.classList.contains('is-open');
            }

            var leaveTimer = null;
            function scheduleClose() { clearTimeout(leaveTimer); leaveTimer = setTimeout(close, 180); }
            function cancelClose() { clearTimeout(leaveTimer); }
            item.addEventListener('mouseenter', function () { cancelClose(); open(); });
            item.addEventListener('mouseleave', scheduleClose);

            // When the trigger is an <a href="..."> link (e.g. Destinations
            // links to /pages/destinations), let the click navigate. Hover
            // already exposes the dropdown. For <button> triggers, click
            // toggles the dropdown as before.
            var triggerIsLink = trigger.tagName === 'A' && trigger.getAttribute('href');
            trigger.addEventListener('click', function (e) {
                if (triggerIsLink) return; // allow normal link navigation
                e.preventDefault();
                if (isOpen()) close(); else open();
            });

            trigger.addEventListener('keydown', function (e) {
                var key = e.key;
                if (key === 'Enter' || key === ' ') {
                    if (triggerIsLink && key === 'Enter') return; // <a> handles Enter natively
                    e.preventDefault();
                    if (isOpen()) close(); else open();
                } else if (key === 'ArrowDown') {
                    e.preventDefault();
                    open();
                    var firstItem = panel.querySelector('[role="menuitem"]');
                    if (firstItem) firstItem.focus();
                } else if (key === 'Escape') {
                    close();
                    trigger.focus();
                }
            });

            var menuItems = panel.querySelectorAll('[role="menuitem"]');
            Array.prototype.forEach.call(menuItems, function (mi, idx) {
                mi.addEventListener('keydown', function (e) {
                    var key = e.key;
                    if (key === 'ArrowDown') {
                        e.preventDefault();
                        var next = menuItems[(idx + 1) % menuItems.length];
                        if (next) next.focus();
                    } else if (key === 'ArrowUp') {
                        e.preventDefault();
                        var prev = menuItems[(idx - 1 + menuItems.length) % menuItems.length];
                        if (prev) prev.focus();
                    } else if (key === 'Home') {
                        e.preventDefault();
                        if (menuItems[0]) menuItems[0].focus();
                    } else if (key === 'End') {
                        e.preventDefault();
                        if (menuItems[menuItems.length - 1]) menuItems[menuItems.length - 1].focus();
                    } else if (key === 'Escape') {
                        e.preventDefault();
                        close();
                        trigger.focus();
                    }
                });
            });

            document.addEventListener('click', function (e) {
                if (!item.contains(e.target)) close();
            });

            document.addEventListener('keydown', function (e) {
                if (e.key === 'Escape' && isOpen()) {
                    close();
                    trigger.focus();
                }
            });
        });
    }

    function initMobileMenu() {
        var drawer = document.getElementById('site-drawer');
        var toggle = document.querySelector('[data-drawer-toggle]');
        var closers = document.querySelectorAll('[data-drawer-close]');
        if (!drawer || !toggle) return;

        function openDrawer() {
            drawer.classList.add('is-open');
            document.body.classList.add('is-drawer-open');
            toggle.setAttribute('aria-expanded', 'true');
        }
        function closeDrawer() {
            drawer.classList.remove('is-open');
            document.body.classList.remove('is-drawer-open');
            toggle.setAttribute('aria-expanded', 'false');
        }

        toggle.addEventListener('click', function () {
            if (drawer.classList.contains('is-open')) closeDrawer();
            else openDrawer();
        });

        Array.prototype.forEach.call(closers, function (el) {
            el.addEventListener('click', closeDrawer);
        });

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
        });

        var accordionTriggers = document.querySelectorAll('[data-drawer-accordion]');
        Array.prototype.forEach.call(accordionTriggers, function (trigger) {
            trigger.addEventListener('click', function () {
                var current = trigger.getAttribute('aria-expanded') === 'true';
                trigger.setAttribute('aria-expanded', current ? 'false' : 'true');
            });
        });

        window.__jcOpenDrawer = openDrawer;
        window.__jcCloseDrawer = closeDrawer;
    }

    function initHeroCarousel() {
        var carousel = document.querySelector('[data-hero-carousel]');
        if (!carousel) return;
        var slides = Array.prototype.slice.call(carousel.querySelectorAll('.hero__media-slide'));
        var captionEl = carousel.querySelector('.js-hero-location');
        var captionWrap = captionEl ? captionEl.parentElement : null;
        if (slides.length < 2 || !captionEl || !captionWrap) return;
        var idx = 0;
        function advance() {
            var next = (idx + 1) % slides.length;
            captionWrap.classList.add('is-fading');
            setTimeout(function () {
                slides[idx].classList.remove('is-active');
                slides[next].classList.add('is-active');
                captionEl.textContent = slides[next].getAttribute('data-location') || '';
                captionWrap.classList.remove('is-fading');
                idx = next;
            }, 360);
        }
        setInterval(advance, 5200);
    }

    function initFieldGuideTabs() {
        var tabs = document.querySelectorAll('.guide__tab');
        if (!tabs.length) return;
        Array.prototype.forEach.call(tabs, function (tab) {
            tab.addEventListener('click', function () {
                var target = tab.getAttribute('data-tab');
                document.querySelectorAll('.guide__tab').forEach(function (t) {
                    t.classList.toggle('is-active', t === tab);
                });
                document.querySelectorAll('.guide__panel').forEach(function (p) {
                    p.classList.toggle('is-active', p.getAttribute('data-panel') === target);
                });
            });
        });
    }

    function initFieldGuideCarousels() {
        document.querySelectorAll('.guide__carousel').forEach(function (carousel) {
            var slides = carousel.querySelectorAll('.guide__carousel-slide');
            var counter = carousel.querySelector('.js-carousel-current');
            var prev = carousel.querySelector('.js-carousel-prev');
            var next = carousel.querySelector('.js-carousel-next');
            var idx = 0;
            function update() {
                slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
                if (counter) counter.textContent = String(idx + 1).padStart(2, '0');
            }
            if (prev) prev.addEventListener('click', function () { idx = (idx - 1 + slides.length) % slides.length; update(); });
            if (next) next.addEventListener('click', function () { idx = (idx + 1) % slides.length; update(); });
        });
    }

    function initStaysCarousel() {
        var carousels = document.querySelectorAll('[data-stays-carousel]');
        if (!carousels.length) return;

        Array.prototype.forEach.call(carousels, function (root) {
            var track = root.querySelector('[data-stays-track]');
            var prev = root.querySelector('[data-stays-prev]');
            var next = root.querySelector('[data-stays-next]');
            if (!track) return;

            function step() {
                // Scroll by ~one card width including its right-side gap.
                var firstCard = track.querySelector('.stay-card');
                if (!firstCard) return track.clientWidth * 0.6;
                var styles = window.getComputedStyle(track);
                var gap = parseFloat(styles.columnGap || styles.gap) || 0;
                return firstCard.getBoundingClientRect().width + gap;
            }

            function updateButtons() {
                if (!prev || !next) return;
                var max = track.scrollWidth - track.clientWidth - 2;
                prev.disabled = track.scrollLeft <= 2;
                next.disabled = track.scrollLeft >= max;
            }

            if (prev) {
                prev.addEventListener('click', function () {
                    track.scrollBy({ left: -step(), behavior: 'smooth' });
                });
            }
            if (next) {
                next.addEventListener('click', function () {
                    track.scrollBy({ left: step(), behavior: 'smooth' });
                });
            }

            track.addEventListener('scroll', updateButtons, { passive: true });
            window.addEventListener('resize', updateButtons);
            // Initial pass after layout settles so scrollWidth is correct.
            requestAnimationFrame(updateButtons);
            setTimeout(updateButtons, 250);
        });
    }

    function initStaysDirectory() {
        var root = document.querySelector('[data-stays-directory]');
        var mapEl = document.getElementById('stays-directory-map');
        if (!root || !mapEl) return;
        if (typeof L === 'undefined') {
            // Leaflet defer-loads; retry once after a tick.
            return setTimeout(function () { safeInit('staysDirectory', initStaysDirectory); }, 250);
        }

        var cards = Array.prototype.slice.call(root.querySelectorAll('.stays-directory__stay'));
        if (!cards.length) return;

        var STAYS = cards.map(function (card, idx) {
            var img = card.querySelector('[data-popup-img]');
            var priceEl = card.querySelector('.stay-card__price');
            return {
                id: card.getAttribute('data-stay-id') || ('stay-' + idx),
                destination: card.getAttribute('data-destination') || '',
                lat: parseFloat(card.getAttribute('data-lat')),
                lng: parseFloat(card.getAttribute('data-lng')),
                name: card.getAttribute('data-name') || '',
                tag: card.getAttribute('data-tag') || '',
                href: card.getAttribute('data-href') || '#',
                imgSrc: img ? img.getAttribute('src') : '',
                priceText: priceEl ? (priceEl.getAttribute('data-price-text') || priceEl.textContent.trim()) : '',
                num: idx + 1,
                card: card
            };
        }).filter(function (s) { return !isNaN(s.lat) && !isNaN(s.lng); });

        if (!STAYS.length) return;

        var map = L.map(mapEl, {
            scrollWheelZoom: false,
            zoomControl: true,
            attributionControl: true
        });

        L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
            subdomains: 'abcd',
            maxZoom: 19
        }).addTo(map);

        var markersById = {};
        var activeId = null;

        STAYS.forEach(function (stay) {
            var icon = L.divIcon({
                className: 'sage-pin',
                html: '<span class="sage-pin__inner">' + stay.num + '</span>',
                iconSize: [32, 32],
                iconAnchor: [16, 16],
                popupAnchor: [0, -16]
            });
            var marker = L.marker([stay.lat, stay.lng], { icon: icon }).addTo(map);
            var popupHTML = '<a class="map-popup" href="' + stay.href + '">' +
                '<span class="map-popup__media"><img src="' + stay.imgSrc + '" alt="" /></span>' +
                '<span class="map-popup__body">' +
                  '<span class="map-popup__tag">' + stay.tag + '</span>' +
                  '<span class="map-popup__name">' + stay.name + '</span>' +
                  '<span class="map-popup__price">' + stay.priceText + '</span>' +
                  '<span class="map-popup__cta">View &rarr;</span>' +
                '</span>' +
              '</a>';
            marker.bindPopup(popupHTML, { closeButton: true, autoPanPadding: [40, 40] });
            marker.on('click', function () { setActive(stay.id, true); });
            marker.on('mouseover', function () { setActive(stay.id, false); });
            markersById[stay.id] = marker;
        });

        function fitToVisible() {
            var visible = STAYS.filter(function (s) {
                var marker = markersById[s.id];
                return marker && map.hasLayer(marker);
            });
            if (!visible.length) return;
            if (visible.length === 1) {
                map.setView([visible[0].lat, visible[0].lng], 12, { animate: true });
            } else {
                var bounds = visible.map(function (s) { return [s.lat, s.lng]; });
                map.fitBounds(bounds, { padding: [44, 44], animate: true });
            }
        }

        function setActive(stayId, scroll) {
            if (activeId === stayId) return;
            activeId = stayId;
            cards.forEach(function (card) {
                card.classList.toggle('is-active', card.getAttribute('data-stay-id') === stayId);
            });
            Object.keys(markersById).forEach(function (id) {
                var el = markersById[id].getElement();
                if (el) el.classList.toggle('is-active', id === stayId);
            });
            if (scroll) {
                var activeCard = root.querySelector('.stays-directory__stay[data-stay-id="' + stayId + '"]');
                if (activeCard) activeCard.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }

        function clearActive() {
            activeId = null;
            cards.forEach(function (c) { c.classList.remove('is-active'); });
            Object.keys(markersById).forEach(function (id) {
                var el = markersById[id].getElement();
                if (el) el.classList.remove('is-active');
            });
        }

        cards.forEach(function (card) {
            var id = card.getAttribute('data-stay-id');
            card.addEventListener('mouseenter', function () { setActive(id, false); });
            card.addEventListener('focusin', function () { setActive(id, false); });
        });

        var chips = root.querySelectorAll('.filter-chip');
        Array.prototype.forEach.call(chips, function (chip) {
            chip.addEventListener('click', function () {
                Array.prototype.forEach.call(chips, function (c) {
                    c.classList.remove('is-active');
                    c.setAttribute('aria-selected', 'false');
                });
                chip.classList.add('is-active');
                chip.setAttribute('aria-selected', 'true');
                var filter = chip.getAttribute('data-filter') || 'all';
                cards.forEach(function (card) {
                    var dest = card.getAttribute('data-destination');
                    var show = (filter === 'all') || (dest === filter);
                    card.classList.toggle('is-hidden', !show);
                });
                STAYS.forEach(function (s) {
                    var marker = markersById[s.id];
                    if (!marker) return;
                    var show = (filter === 'all') || (s.destination === filter);
                    if (show && !map.hasLayer(marker)) marker.addTo(map);
                    if (!show && map.hasLayer(marker)) map.removeLayer(marker);
                });
                clearActive();
                fitToVisible();
            });
        });

        fitToVisible();
    }

    function initContactForms() {
        var forms = document.querySelectorAll('form.js-contact-form');
        if (!forms.length) return;

        var ENDPOINT = '/contact#contact_form';
        var FALLBACK = 'Sorry, that did not go through. Email johannaanorve8@gmail.com or call 917.208.0959.';

        Array.prototype.forEach.call(forms, function (form) {
            var statusEl = form.querySelector('.js-form-status');
            if (!statusEl) {
                statusEl = document.createElement('div');
                statusEl.className = 'js-form-status form-status';
                statusEl.setAttribute('role', 'status');
                statusEl.setAttribute('aria-live', 'polite');
                var submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
                if (submitBtn && submitBtn.parentNode) {
                    submitBtn.parentNode.insertBefore(statusEl, submitBtn);
                } else {
                    form.appendChild(statusEl);
                }
            }

            form.addEventListener('submit', function (e) {
                e.preventDefault();

                var honeypots = form.querySelectorAll('input[name="website"], input[name="company"]');
                for (var i = 0; i < honeypots.length; i++) {
                    if (honeypots[i].value) {
                        renderSuccess(statusEl);
                        return;
                    }
                }

                var btn = form.querySelector('button[type="submit"], input[type="submit"]');
                var originalLabel = null;
                if (btn) {
                    originalLabel = btn.textContent;
                    btn.disabled = true;
                    btn.textContent = 'Sending...';
                }
                statusEl.className = 'js-form-status form-status form-status--pending';
                statusEl.textContent = '';

                var data = new FormData(form);
                data.delete('website');
                data.delete('company');

                var intent = data.get('contact[Form intent]') || 'INQUIRY';
                var existingBody = data.get('contact[body]') || '';

                var bodyLines = [];
                bodyLines.push('[' + intent + ']');
                bodyLines.push('Source page: ' + window.location.href);
                bodyLines.push('');

                var entries = [];
                data.forEach(function (value, key) { entries.push([key, value]); });
                entries.forEach(function (entry) {
                    var key = entry[0];
                    var value = entry[1];
                    if (key === 'contact[body]' || key === 'contact[email]' || key === 'contact[Form intent]') return;
                    if (key.indexOf('contact[') !== 0) return;
                    if (typeof value === 'string' && value.trim()) {
                        var label = key.replace(/^contact\[/, '').replace(/\]$/, '');
                        bodyLines.push(label + ': ' + value);
                    }
                });

                if (existingBody && existingBody.toString().trim()) {
                    bodyLines.push('');
                    bodyLines.push('Message:');
                    bodyLines.push(existingBody);
                }

                data.set('contact[body]', bodyLines.join('\n'));

                fetch(ENDPOINT, {
                    method: 'POST',
                    body: data,
                    redirect: 'follow',
                    credentials: 'same-origin'
                }).then(function (response) {
                    if (btn) {
                        btn.disabled = false;
                        btn.textContent = originalLabel;
                    }
                    var ok = response.ok || response.redirected ||
                        (response.url && response.url.indexOf('contact_posted=true') !== -1);
                    if (ok) {
                        var customMsg = form.getAttribute('data-success-msg');
                        renderSuccess(statusEl, customMsg);
                        form.reset();
                    } else {
                        renderError(statusEl, FALLBACK);
                    }
                }).catch(function () {
                    if (btn) { btn.disabled = false; btn.textContent = originalLabel; }
                    renderError(statusEl, FALLBACK);
                });
            });
        });

        function renderSuccess(status, msg) {
            status.className = 'js-form-status form-status form-status--success';
            status.textContent = msg || 'Thanks. Johanna will reply within a few hours.';
        }
        function renderError(status, msg) {
            status.className = 'js-form-status form-status form-status--error';
            status.textContent = msg;
        }
    }

    function boot() {
        safeInit('headerScroll', initHeaderScroll);
        safeInit('headerDropdown', initHeaderDropdown);
        safeInit('mobileMenu', initMobileMenu);
        safeInit('heroCarousel', initHeroCarousel);
        safeInit('fieldGuideTabs', initFieldGuideTabs);
        safeInit('fieldGuideCarousels', initFieldGuideCarousels);
        safeInit('staysCarousel', initStaysCarousel);
        safeInit('staysDirectory', initStaysDirectory);
        safeInit('contactForms', initContactForms);
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }
})();
